import script from "./TabLgpd.vue?vue&type=script&setup=true&lang=js"
export * from "./TabLgpd.vue?vue&type=script&setup=true&lang=js"

import "./TabLgpd.vue?vue&type=style&index=0&id=780a6bd8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780a6bd8"]])

export default __exports__